/** Decorative blueprint / floor-plan art for the hero background */
export const HeroFloorPlan = ({ variant = "full" }) => {
    const showPanel = variant === "full" || variant === "panel";
    const showStage = variant === "full" || variant === "stage";
    const showShared = variant === "full";

    return (
        <svg
            className="pointer-events-none absolute inset-0 h-full w-full text-brand-teal"
            viewBox="0 0 1440 900"
            preserveAspectRatio="xMidYMid slice"
            aria-hidden="true"
            data-testid="hero-floor-plan"
        >
            {showPanel && (
                <g className={variant === "full" ? "hidden lg:block" : undefined} opacity="0.55">
                    <rect x="780" y="140" width="320" height="240" fill="rgba(6,78,87,0.035)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.14" />
                    <rect x="780" y="140" width="320" height="240" fill="none" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.08" strokeDasharray="6 8" />

                    <rect x="780" y="380" width="180" height="160" fill="rgba(6,78,87,0.04)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.16" />
                    <rect x="960" y="380" width="140" height="160" fill="rgba(253,185,39,0.04)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.12" />

                    <path d="M 960 460 A 24 24 0 0 1 936 484" fill="none" stroke="currentColor" strokeWidth="1" strokeOpacity="0.2" />
                    <line x1="960" y1="460" x2="960" y2="484" stroke="currentColor" strokeWidth="1" strokeOpacity="0.2" />
                    <line x1="936" y1="484" x2="960" y2="484" stroke="currentColor" strokeWidth="1" strokeOpacity="0.2" />

                    <line x1="780" y1="108" x2="1100" y2="108" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.22" />
                    <line x1="780" y1="96" x2="780" y2="120" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.22" />
                    <line x1="1100" y1="96" x2="1100" y2="120" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.22" />
                    <text x="940" y="98" textAnchor="middle" fill="currentColor" fillOpacity="0.35" fontFamily="JetBrains Mono, monospace" fontSize="11" letterSpacing="0.12em">
                        4.80 m
                    </text>

                    <line x1="1140" y1="140" x2="1140" y2="540" stroke="#FDB927" strokeWidth="0.75" strokeOpacity="0.35" />
                    <line x1="1128" y1="140" x2="1152" y2="140" stroke="#FDB927" strokeWidth="0.75" strokeOpacity="0.35" />
                    <line x1="1128" y1="540" x2="1152" y2="540" stroke="#FDB927" strokeWidth="0.75" strokeOpacity="0.35" />
                    <text
                        x="1156"
                        y="345"
                        textAnchor="start"
                        fill="#FDB927"
                        fillOpacity="0.45"
                        fontFamily="JetBrains Mono, monospace"
                        fontSize="11"
                        letterSpacing="0.12em"
                        transform="rotate(90 1156 345)"
                    >
                        3.20 m
                    </text>

                    <text x="940" y="268" textAnchor="middle" fill="currentColor" fillOpacity="0.22" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.28em">
                        LIVING
                    </text>
                    <text x="870" y="472" textAnchor="middle" fill="currentColor" fillOpacity="0.2" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.28em">
                        KITCHEN
                    </text>
                    <text x="1030" y="472" textAnchor="middle" fill="currentColor" fillOpacity="0.18" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.28em">
                        BATH
                    </text>

                    <circle cx="1180" cy="620" r="28" fill="none" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.15" />
                    <line x1="1180" y1="596" x2="1180" y2="644" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.2" />
                    <line x1="1156" y1="620" x2="1204" y2="620" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.2" />
                    <text x="1180" y="592" textAnchor="middle" fill="currentColor" fillOpacity="0.25" fontFamily="JetBrains Mono, monospace" fontSize="9">
                        N
                    </text>
                </g>
            )}

            {showStage && (
                <g className={variant === "full" ? "lg:hidden" : undefined} opacity="0.5">
                    <rect x="80" y="620" width="520" height="200" fill="rgba(6,78,87,0.03)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.12" />
                    <rect x="80" y="620" width="280" height="200" fill="rgba(6,78,87,0.04)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.14" />
                    <rect x="360" y="620" width="240" height="120" fill="rgba(253,185,39,0.04)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.12" />
                    <rect x="360" y="740" width="240" height="80" fill="rgba(6,78,87,0.035)" stroke="currentColor" strokeWidth="1" strokeOpacity="0.1" />

                    <line x1="80" y1="588" x2="600" y2="588" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.18" />
                    <line x1="80" y1="576" x2="80" y2="600" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.18" />
                    <line x1="600" y1="576" x2="600" y2="600" stroke="currentColor" strokeWidth="0.75" strokeOpacity="0.18" />
                    <text x="340" y="580" textAnchor="middle" fill="currentColor" fillOpacity="0.3" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.14em">
                        6.40 m
                    </text>

                    <text x="220" y="728" textAnchor="middle" fill="currentColor" fillOpacity="0.2" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.26em">
                        OPEN PLAN
                    </text>
                    <text x="480" y="688" textAnchor="middle" fill="currentColor" fillOpacity="0.18" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="0.26em">
                        KITCHEN
                    </text>
                </g>
            )}

            {showShared && (
                <g opacity="0.35">
                    <line x1="40" y1="820" x2="420" y2="820" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.12" strokeDasharray="4 10" />
                    <line x1="40" y1="860" x2="280" y2="860" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.1" strokeDasharray="4 10" />
                    <circle cx="52" cy="820" r="2.5" fill="currentColor" fillOpacity="0.15" />
                    <circle cx="420" cy="820" r="2.5" fill="currentColor" fillOpacity="0.15" />
                </g>
            )}
        </svg>
    );
};
